import { render } from "./MainFooter.vue?vue&type=template&id=f4f16c48"
import script from "./MainFooter.vue?vue&type=script&lang=js"
export * from "./MainFooter.vue?vue&type=script&lang=js"

import exportComponent from "/Users/medvedevpavel/Documents/code/lb_advice/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__